import { render, staticRenderFns } from "./detailManagementTeam.vue?vue&type=template&id=d42e3e02&scoped=true"
import script from "./detailManagementTeam.vue?vue&type=script&lang=js"
export * from "./detailManagementTeam.vue?vue&type=script&lang=js"
import style0 from "./detailManagementTeam.vue?vue&type=style&index=0&id=d42e3e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42e3e02",
  null
  
)

export default component.exports